<template>
    <div class="btn-container">
        <div v-if="showButtonPrevious" class="btn-style">
            <CieloButton :transparent="true" @click="$emit('click-previous')">
                <span class="btn-text btn-prev" v-text="$ml.get(backText)" />
            </CieloButton>
        </div>
        <div v-if="showButtonNext" class="btn-style">
            <CieloButton
                :loading="loading"
                :disabled="disableButtonNext"
                :class="success ? 'btn btn-success' : ''"
                @click="$emit('click-next')"
            >
                <span class="btn-text btn-next" v-text="$ml.get(nextText)" />
            </CieloButton>
        </div>
    </div>
</template>

<script>
const CieloButton = () => import(
	/* webpackChunkName: "cielo-button" */
	'@/components/template/CieloButton'
);

export default {
	props: {
		showButtonPrevious: {
			type: Boolean,
			default: true
		},
		showButtonNext: {
			type: Boolean,
			default: true
		},
		success: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		disableButtonNext: {
			type: Boolean,
			default: true
		},
		backText: {
			type: String,
			default: 'back'
		},
		nextText: {
			type: String,
			default: 'continue'
		}
	},

	components: {
		CieloButton,
	},
};

</script>

<style lang="scss" scoped>
.btn-container {
	@media screen and (max-width: 1024px) {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 20px;
}

.btn-style {
	@media screen and (max-width: 1024px) {
		flex-direction: column;
		align-items: flex-start;
		width: 100%;

	}
	
	align-items: flex-start;
	flex: 1
}

.btn-text {
	font-weight: 600;
	line-height: 24px;
}

.btn-prev {
	font-size: 16px !important;
}

.btn-next {
	font-size: 16px;
}
</style>
